export default "__VITE_ASSET__BgCUJq____"